<template>
    <div>
        <label :class="['label-text', fieldData.end_date.hasError ? 'error' : '']">
            {{ fieldData.end_date.label }}
        </label>
        <date-picker
            v-model="fieldData.end_date.tempEndDate"
            :months="months"
            :weekdays="weekdays"
            :class="['placedatepickercrossinmiddle', fieldData.end_date.hasError ? 'errorinput' : '', fieldData.end_date.editable === false ? 'disableddateto' : '', 'datepicker']"
            :editable="fieldData.end_date.editable"
            :show-week-number="true"
            valueType="format"
            :disabled-date="isDateDisabled"
            :clearable="false"
            :disabled="fieldData.end_date.disabled"
            :lang="enSv"
        ></date-picker>
        <label class="text-danger" v-if="fieldData.end_date.errorMsg.length > 0">{{ fieldData.end_date.errorMsg }}</label>
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker"
import "vue2-datepicker/index.css"
import "vue2-datepicker/locale/en"
import computedVal from "@/mixins/computedVal"
import props from "@/mixins/inputProps"
import propsDate from "@/mixins/inputPropsDate"
import datePickerConfig from "@/mixins/datePickerConfig"
import { isDateNotBetweenTwoDates, dateToyymmddFormat } from "../../../../api/utils.js"
import dayjs from "dayjs"
import sv from 'vue2-datepicker/locale/sv'

export default {
    name: "DateToChannels",
    components: {
        DatePicker,
    },
    mixins: [computedVal, props, propsDate, datePickerConfig],
    computed: {
        enSv() {
            sv.formatLocale.monthsShort = this.monthsShort
            return {
                ...sv,
                days: [...this.weekdays],
                months: [...this.months],
            }
        },
        isDateValidFormat() {
            return dayjs(this.fieldData.end_date.tempEndDate, "YYYY-MM-DD").format("YYYY-MM-DD") === this.fieldData.end_date.tempEndDate
        },
    },
    async mounted() {
        await this.loadGlobalConfigFromFile()
        if (this.fieldData.end_date.tempEndDate) this.checkIfError(this.fieldData.end_date.tempEndDate)
    },
    methods: {
        isDateDisabled(datepickerDate) {
            let disableDate = false
            let startDate = new Date(this.fieldData.end_date.datePeriod.fromDate)
            let endDate = new Date(this.fieldData.end_date.datePeriod.endDate)
            let datepickerDateDayjsObj = dayjs(dateToyymmddFormat(datepickerDate))
            let isWeek = this.fieldData.grouptime.tempGroupTime.id === "week"
            //if datepicker date is not sunday and week is chosen or datepickerdate is not between publishfromdate and publishenddate disable date
            if ((datepickerDateDayjsObj.get("d") !== 0 && isWeek) || isDateNotBetweenTwoDates(datepickerDate, startDate, endDate)) disableDate = true
            let toV3ChangeDate = new Date(this.config_ToV3ChangeDate)
            toV3ChangeDate.setHours(0, 0, 0)
            if (datepickerDate < toV3ChangeDate) disableDate = true
            return disableDate
        },
        checkIfError(chosendate) {
            this.fieldData.end_date.hasError = false
            this.fieldData.end_date.errorMsg = ""
            if ((this.isDateDisabled(new Date(chosendate)) && this.fieldData.end_date.required) || !this.isDateValidFormat) {
                this.fieldData.end_date.hasError = true
                this.fieldData.end_date.errorMsg = "Viewing data is missing for the selected date or the date is in the wrong format"
            }
        },
    },
    watch: {
        "fieldData.end_date.tempEndDate"(chosendate) {
            this.checkIfError(chosendate)
        },
    },
}
</script>

<style scoped>
input {
    height: 30px !important;
    box-sizing: border-box;
    border: 1px solid #ced4da;
    padding: 2px 5px !important;
}
.disableddateto >>> input {
    background-color: var(--vs-disabled-bg);
    cursor: var(--vs-disabled-cursor);
}
</style>
